import { AccessRefreshToken, OAuthIntegration } from '@glueapp/graph-types';
import { googleAuthorizeUrl, GoogleBaseIntegration } from '../BaseIntegration';

const scopes = ['https://www.googleapis.com/auth/gmail.modify'];

export const GmailIntegration: OAuthIntegration<AccessRefreshToken, { GOOGLE_CLIENT_ID: string; GOOGLE_CLIENT_SECRET: string }, {}> = {
    integrationType: 'oauth',
    ...GoogleBaseIntegration,
    getAuthorizationUrl(
        oauthState: string,
        redirectUri: string,
        secrets: { GOOGLE_CLIENT_ID: string; GOOGLE_CLIENT_SECRET: string },
    ): string {
        return `${googleAuthorizeUrl}?client_id=${secrets.GOOGLE_CLIENT_ID}&access_type=offline&scope=${scopes.join(
            ',',
        )}&state=${oauthState}&redirect_uri=${redirectUri}&response_type=code`;
    },
    renderOptionLabel: () => 'GMail',
    requiredSecrets: ['GOOGLE_CLIENT_ID', 'GOOGLE_CLIENT_SECRET'],
    provider: 'google_mail',
    allowedDomains: ['gmail.googleapis.com', 'googleapis.com'],
};
